var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex mb-n12 mt-0",attrs:{"elevation":"0","flat":"","tile":""}},[_c('FilterList',{attrs:{"multiple":false,"options":_vm.isBusinessOptions,"text":"text","icon":true,"label":"clientType"},on:{"update-filter":_vm.updateIsBusiness}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }